import { WithdrawalsReceiveGetLimitsReducer } from './types';

export const withdrawalsReceiveGetLimitsReducer: WithdrawalsReceiveGetLimitsReducer =
  (state, action) => {
    const { items, currencies, aggregatorIds } = action.payload;

    return {
      ...state,
      withdrawalsLimits: {
        items,
        currencies,
        aggregatorIds,
      },
      withdrawalsLimitsProcessedItems: items,
    };
  };
